import m from "../../geodata/es2015/ecuadorHigh";
window.am4geodata_ecuadorHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ecuadorHigh.js
// module id = null
// module chunks = 